<template>
    <div class="pop_overlay_black" v-if="isShow" style="z-index:9999">
        <div class="pop_wrap pop_noti">
            <div v-if="isLoading" class="loading_bg transparent" style="z-index: 999;">
                <div class="loading_wrap">
                    <div class="loading_obj">
                        <svg class="spinner" width="60px" height="60px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                            <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
                        </svg>
                    </div>
                </div>
            </div>
            <button  class="pop_noti_close" :disabled="isLoading" v-if="usingCloseButton" @click.stop="action_Close">
                <v-icon>mdi-close</v-icon>
            </button>
            <div class="pop_noti_danger_wrap" v-if="usingAlertTag">
                <span class="pop_noti_danger"><v-icon class="red_txt">mdi-alert-circle</v-icon> {{ $t('common.label_danger_alert') }}</span>
            </div>
            <div class="cont">
                <pre>{{ text }}</pre>
            </div>
            <div class="pop_noti_btn_wrap">
                <button class="btn btn_s btn_gray" :disabled="isLoading" @click.stop="action_Left">
                    {{ lButtonTitle }}
                </button>
                <button class="btn btn_s btn_blue" :disabled="isLoading" @click.stop="action_Right">
                    {{ rButtonTitle }}
                </button>
            </div>
        </div>
    </div>
</template>


<script>
export default {
    data() {
        return {
            isLoading: false,
        }
    },
    watch: {},
    computed: {
        currentAlert: function() { return this.AlertController.currentAlert?.alert },
        isShow: function() { return this.currentAlert != undefined },
        usingCloseButton: function() { return this.currentAlert?.usingCloseButton },
        usingAlertTag: function() { return this.currentAlert?.usingAlertTag },
        text: function() { return this.currentAlert?.text },
        lButtonTitle: function() { return this.currentAlert?.lButtonTitle ?? this.$t('common.cancel') },
        rButtonTitle: function() { return this.currentAlert?.rButtonTitle ?? this.$t('common.confirm') },
        resolve: function() { return this.AlertController.resolve }
    },
    methods: {
        async action_Close() {
            if (this.currentAlert?.cHandler != undefined) {
                await this.currentAlert?.cHandler()
            }
            if (this.resolve != undefined) { this.resolve('close') }
            this.AlertController.hideAlert()
        },
        async action_Left() {
            if (this.currentAlert?.lHandler != undefined) {
                await this.currentAlert?.lHandler()
            }
            if (this.resolve != undefined) { this.resolve('left') }
            this.AlertController.hideAlert()
        },
        async action_Right() {
            if (this.currentAlert?.rHandler != undefined) {
                await this.currentAlert?.rHandler()
            }
            if (this.resolve != undefined) { this.resolve('right') }
            this.AlertController.hideAlert()
        },
    }
}
</script>